var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Listado de siniestros para extranet")]),_vm._v(" "),_c('filter-sinisters',{on:{"change":_vm.fetchSinisters}}),_vm._v(" "),_c('selected-sinisters-summary',{attrs:{"items":_vm.selectedSinisters},on:{"save":_vm.submitPackage}}),_vm._v(" "),_c('table-actions',{attrs:{"tableHeaders":_vm.headers,"title":"Siniestros para armado de paquetes","tableData":_vm.sinisterList},on:{"selected":_vm.onSelected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/pages/extranet/SinisterPackages.vue